import { adminAPI } from "../../api/adminAPI";
import {
  loadClients,
  loadDrivers,
  loadProfiles,
  loadServices,
  loadUsers,
  loadUsersApp,
  setLoading,
  setValueDate, setValueModuleStatus,
} from './adminSlice'

export const getProfiles = () => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .get("/profile", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    const { status } = response;
    if (status !== 200) {
      const { message } = response.data;
      const { status } = response;
      dispatch(loadUsers({ message, status }));
      return;
    }
    const { data } = response.data;
    dispatch(loadProfiles({ data, status }));
  };
};

export const getAdminUsers = () => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .get("/admin", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);

    const { status } = response;
    if (status !== 200) {
      const { message } = response.data;
      const { status } = response;
      dispatch(loadUsers({ message, status }));
      return;
    }
    const { data } = response.data;
    dispatch(loadUsers({ data, status }));
  };
};

export const getClients = () => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .get("/admin-client", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    const { status } = response;
    const { data } = response.data;
    if (status !== 200) {
      const { message } = response.data;
      dispatch(loadClients({ message, status }));
      return;
    }
    dispatch(loadClients({ data, status }));
  };
};

export const getUsersApp = () => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .get("/admin-client/app-client", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    const { status } = response;
    const { data } = response.data;
    if (status !== 200) {
      const { message } = response.data;
      dispatch(loadUsersApp({ message, status }));
      return;
    }
    dispatch(loadUsersApp({ data, status }));
  };
};

function toYYYYMMDD(dateOrStr) {
  if (!dateOrStr) return "";
  if (dateOrStr instanceof Date) {
    const y = dateOrStr.getFullYear();
    const m = String(dateOrStr.getMonth() + 1).padStart(2, "0");
    const d = String(dateOrStr.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return String(dateOrStr);
}

// El backend aplica los filtros (fecha, status). El frontend muestra todo lo que devuelve el API.
export const getServices = (dateToFilter = "", moduleStatus = "", dateValue = "") => {
  return async (dispatch, actualState) => {
    dispatch(setLoading());
    const hasRange = typeof dateValue === "string" && dateValue.includes("|");
    const params = new URLSearchParams();
    if (hasRange) {
      const [startDate, endDate] = dateValue.split("|");
      if (startDate) params.set("startDate", startDate);
      if (endDate) params.set("endDate", endDate);
    } else if (dateToFilter) {
      params.set("date", toYYYYMMDD(dateToFilter));
    }
    if (moduleStatus) params.set("moduleStatus", moduleStatus);
    const query = params.toString();
    const response = await adminAPI
      .get(`/services${query ? `?${query}` : ""}`, {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    const { status } = response;
    const { data } = response.data;

    if (status !== 200) {
      const { message } = response.data;
      dispatch(loadServices({ message, status }));
      return;
    }
    // 1. Los SIN MÓDULO ordenados por fecha ascendente (más viejos primero)
    const sinModulo = data.filter(item => item.moduleStatus === 'SIN MÓDULO')
      .sort((a, b) => new Date(a.creationDate) - new Date(b.creationDate));
    // 2. El resto ordenados por fecha descendente (más recientes primero)
    const resto = data.filter(item => item.moduleStatus !== 'SIN MÓDULO')
      .sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate));
    const sortedData = [...sinModulo, ...resto];
    dispatch(loadServices({ data: sortedData, status }));
  };
};

export const getDrivers = () => {
  return async (dispatch, actualState) => {
    dispatch(setLoading());
    const response = await adminAPI
      .get("/drivers", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    const { status } = response;
    const { data } = response.data;
    if (status !== 200) {
      const { message } = response.data;
      dispatch(loadDrivers({ message, status }));
      return;
    }
    dispatch(loadDrivers({ data, status }));
  };
};

export const deleteServiceFromApi = (idService) => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .delete(`/services/${idService}`, {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);

    const { status } = response;
    const { data } = response.data;

    if (status !== 200) {
      const { message } = response.data;
      dispatch(loadServices({ message, status }));
      return;
    }
    dispatch(loadServices({ data, status }));
  };
};

export const setDateForSearch = (valueDate) => {
  return (dispatch) => dispatch(setValueDate(valueDate));
};

export const setModuleStatusForSearch = (valueDate) => {
  return (dispatch) => dispatch(setValueModuleStatus(valueDate));
};

// export const deletePermission = (idPermission = 0, idProfile = 0) => {
//   return async(dispatch)=>{
//   const response= await adminAPI.get("/profile")
//   }
// };
